import { FileIds } from '@core/data-access/models/file-upload.model';

export enum FormName {
  Login = 'login',
  Registration = 'registration',
  TicketSelection = 'ticketSelection',
  Questionnaire = 'questionnaire',
  Legitimation = 'legitimation',
  EditUserProfile = 'editUserProfile',
  SavedTicketHolders = 'savedTicketHolders',
  CreateTicketHolder = 'createTicketHolder',
  OrderEditTicketHolder = 'orderEditTicketHolder',
  BuyerInformation = 'buyerInformation',
  BuyerBillingAddress = 'buyerBillingAddress',
  BuyerPrivacyPolicy = 'buyerPrivacyPolicy',
  BuyerQuestionnaire = 'buyerQuestionnaire',
  TicketHolder = 'ticketHolder',
  TicketHolderQuestionnaire = 'ticketHolderQuestionnaire',
  TicketHolderPrivacyPolicy = 'ticketHolderPrivacyPolicy',
  Workshop = 'workshop',
  ConfirmationCheckboxes = 'confirmationCheckboxes',
  ReCaptcha = 'reCaptcha',
  Payment = 'payment'
}

export type FormNames = FormName[];

export type FormValues<T = FormValue> = Record<string, T>;

export type FormValue = string | boolean | Date | FileIds | object;

export type QuestionnaireFormValues = Record<string, QuestionnaireFormValue>;

export type QuestionnaireFormValue = {
  fieldId: number;
  valueId: number;
  text: string;
};
